export const DocumentsModalStyles = {
    headerTitle: {
        textAlign: 'center',
        marginBottom: 20,
        fontSize: '18px',
        fontWeight: 500
    }
};
